<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    inventoryId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "consumablesclaim",
      key: "id",
      url: {
        //   get: '/admin/system/inventory',
        // add: '/admin/system/inventory',
        // add: '/admin/system/inventory/receive',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        { label: "领用数量", name: "receiveNum", value: "", type: "number",max:100,desc:"一次最多领用数量100",width:"400px",rules: [{ required: true, trigger: 'blur',message: "领用数量不能为空",type:"number" }]},
        { label: "备注", name: "remark", value: "", type: "textarea" },
      ],
      forms: {
        receiveNum:"",
        inventoryId: this.inventoryId,
      },
    };
  },
  created() {
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/customer/customer/inventory/receive`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 1000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 1000);
            });
        }
      });
    },
  },
};
</script>
